<template>
  <div :class="['shift-form-container', {show: show}]" @click="hideForm">
    <div class="shift-form" @click.stop v-if="!forHomeSector">
      <div class="title">{{ title }}</div>
      <div class="form-container">
        <div class="row">
          <div class="small-12 columns">
            <div class="field-input">
              <label>SECTOR:</label>
              <select v-model.number="selectedSector" @change="getSubsectors(true)">
                <option :value="-1">Choose a sector</option>
                <option v-for="sector in sectors" :value="sector.ID">{{ sector.name }}</option>
              </select>
            </div>
          </div>
          <!--div class="small-6 columns padding-L">
            <div class="field-input">
              <label>SUBSECTOR:</label>
              <select v-model.number="selectedSubsector" :disabled="subsectors.length <= 0">
                <option :value="-1">Choose a subsector</option>
                <option v-for="subsector in subsectors" :value="subsector.ID">{{ subsector.name }}</option>
              </select>
            </div>
          </div-->
        </div>
        <div class="row margin-T">
          <div class="small-7 columns">
            <div class="field-input">
              <label>START DATE:</label>
              <date-picker calendar-class="drivershift-calendar" :inline="true" v-model="shiftDay" :disabled="calendarDisabled"></date-picker>
            </div>
          </div>

          <div class="small-5 columns">
            <div class="field-input" style="padding-left:10px">
              <label>START TIME:</label>
              <select v-model="timeSelected" @change="getSubsectors(true)">
                <option :value="-1">Choose time</option>
                <option value="AM">AM Start</option>
                <option value="PM">PM Start</option>
                <!-- <option value="3am">3am - 2pm</option>
                <option value="1pm">1pm - 10pm</option>
                <option value="8pm">8pm - 4am</option>
                <option value="custom">Custom</option> -->
              </select>
            </div>
            <div class="time-picker" v-if="timeSelected === 'custom'">
              <span class="inline selection">
                <div class="control" @click="setHour(true)"><i class="fa fa-chevron-up"></i></div>
                <div class="value">{{ timeHour }}</div>
                <div class="control" @click="setHour(false)"><i class="fa fa-chevron-down"></i></div>
              </span>
              <span class="inline separator">:</span>
              <span class="inline selection">
                <div class="control" @click="setMinute(true)"><i class="fa fa-chevron-up"></i></div>
                <div class="value">{{ timeMinute }}</div>
                <div class="control" @click="setMinute(false)"><i class="fa fa-chevron-down"></i></div>
              </span>
              <span class="inline separator">:</span>
              <span class="inline selection">
                <div class="control" @click="setAmPm"><i class="fa fa-chevron-up"></i></div>
                <div class="value">{{ timeAmPm }}</div>
                <div class="control" @click="setAmPm"><i class="fa fa-chevron-down"></i></div>
              </span>
            </div>
            <div class="field-input shift-duration" v-if="timeSelected === 'custom'">
              <label>DURATION:</label>
              <select v-model.number="shiftDuration">
                <option v-for="n in durationRange" :value="n">{{ n + (n > 1 ? ' hours' : ' hour')}}</option>
              </select>
            </div>

            <div v-bind:class="{ 'form-controls': true, 'show-delete': isEdit }">
              <a v-bind:class="{ 'button cta xsmall success block': true, disabled: saving }" href="javascript:;" @click="save">
                <i class="fa fa-spinner fa-spin" v-show="saving"></i>
                <span v-show="!saving">SAVE</span>
              </a>
              <a v-bind:class="{ 'button cta xsmall error block': true, disabled: deleting }" href="javascript:;" @click="deleteShift" v-show="isEdit">
                <i class="fa fa-spinner fa-spin" v-show="deleting"></i>
                <span v-show="!deleting">DELETE</span>
              </a>

              <a class="button cta xsmall secondary block" href="javascript:;" @click="hideForm">CANCEL</a>
            </div>
          </div>
        </div>

        <div class="error-message" v-show="error.show">{{ error.message }}</div>
      </div>
    </div>

    <div class="shift-form" @click.stop v-else>
      <div class="title">{{ title }}</div>
      <div class="form-container">
        <div class="row">
          <div class="small-12 columns">
            <div class="field-input">
              <label>SECTOR:</label>
              <select v-model.number="selectedSector" @change="getSubsectors(true)">
                <option :value="-1">Choose a sector</option>
                <option v-for="sector in sectors" :value="sector.ID">{{ sector.name }}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="row margin-T">
          <div class="small-3 small-push-6 columns padding-R">
            <a class="button cta xsmall secondary block" href="javascript:;" @click="hideForm">CANCEL</a>
          </div>
          <div class="small-3 columns padding-L">
            <a v-bind:class="{ 'button cta xsmall success block': true, disabled: saving }" href="javascript:;" @click="saveHomeSector">
              <i class="fa fa-spinner fa-spin" v-show="saving"></i>
              <span v-show="!saving">SAVE</span>
            </a>
          </div>
        </div>
        <div class="error-message" v-show="error.show">{{ error.message }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import DatePicker from 'vuejs-datepicker'
export default {
  name: 'shift-form',
  components: { DatePicker },
  data () {
    return {
      calendarDisabled: {
        to: null
      },
      durationRange: 12,
      error: {
        show: false,
        message: 'This is an error message.'
      },
      saving: false,
      deleting: false,
      timeSelected: -1
    }
  },
  computed: {
    show () { return this.$store.state.provider.shiftForm.show },
    forHomeSector () { return this.$store.state.provider.shiftForm.forHomeSector },
    title () { return this.$store.state.provider.shiftForm.title },
    isEdit () { return this.$store.state.provider.shiftForm.isEdit },
    timeHour () {
      let hour = this.$store.state.provider.shiftForm.timeHour
      if (hour < 10) {
        hour = '0' + hour
      }
      return '' + hour
    },
    timeMinute () {
      let minute = this.$store.state.provider.shiftForm.timeMinute
      if (minute < 10) {
        minute = '0' + minute
      }
      return '' + minute
    },
    shiftDay: {
      get () { return this.$store.state.provider.shiftForm.shiftDay },
      set (value) { this.$store.commit('provider/setShiftFormShiftDay', value) }
    },
    timeAmPm () { return this.$store.state.provider.shiftForm.timeAmPm },
    shiftDuration: {
      get () { return this.$store.state.provider.shiftForm.shiftDuration},
      set (value) { this.$store.commit('provider/setShiftFormShiftDuration', value) }
    },
    sectors () { return this.$store.state.provider.shiftForm.sectors },
    selectedSector: {
      get () { return this.$store.state.provider.shiftForm.selectedSector },
      set (value) { this.$store.commit('provider/setShiftFormSelectedSector', value) }
    },
    subsectors () { return this.$store.state.provider.shiftForm.subsectors },
    selectedSubsector: {
      get () { return this.$store.state.provider.shiftForm.selectedSubsector },
      set (value) { this.$store.commit('provider/setShiftFormSelectedSubsector', value) }
    }
  },
  methods: {
    saveHomeSector () {
      let self = this

      self.error.show = false
      self.error.message = ''
      if (self.selectedSector === -1) {
        self.error.show = true
        self.error.message = 'Please choose a sector.'
        return
      }
      self.saving = true

      let provId = self.$store.state.provider.id
      self.$sdk.post('/provider/' + provId, {
        token: self.$store.state.session.sessionToken,
        homeSectorId: self.selectedSector
      }, r => {
        self.saving = false
        self.$store.commit('provider/setHomeSectorId', self.selectedSector)
        self.$store.commit('provider/setShiftFormShow', false)
        self.$store.commit('provider/setShiftFormSave', false)
      })
    },
    save () {
      let self = this
      if (!self.isValid()) {
        return
      }
      self.saving = true

      let day = moment(self.shiftDay).format('MM/DD/YYYY')
      let hour = ''
      let minute = ''
      let ampm = ''
      let shiftStart = ''
      let shiftEnd = ''
      let format = 'MM/DD/YYYY hh:mm A'
      if (self.timeSelected == 'custom') {
        hour = self.timeHour
        minute = self.timeMinute
        ampm = self.timeAmPm
        shiftStart = moment(day + ' ' + hour + ':' + minute + ' ' + ampm, format)
        shiftEnd = moment(day + ' ' + hour + ':' + minute + ' ' + ampm, format).add(self.shiftDuration, 'hours')
      } else {
        let startTime = '03:00 AM'
        let shiftDuration = 11
        if (self.timeSelected === '1pm') {
          startTime = '01:00 PM'
          shiftDuration = 9
        } else if (self.timeSelected === '8pm') {
          startTime = '08:00 PM'
          shiftDuration = 8
        } else if (self.timeSelected === 'AM') {
          startTime = '12:00 AM'
          shiftDuration = 12
        } else if (self.timeSelected === 'PM') {
          startTime = '12:00 PM'
          shiftDuration = 12
        }
        shiftStart = moment(day + ' ' + startTime, format)
        shiftEnd = moment(day + ' ' + startTime, format).add(shiftDuration, 'hours')
      }

      let request = {
        token: self.$store.state.session.sessionToken,
        driverId: self.$store.state.provider.id,
        driverHomeSectorId: null,
        driverHomeSubsectorId: null,
        driverWorkSectorId: self.selectedSector,
        driverWorkSubsectorId: null,
        startTimestamp: shiftStart.unix(),
        endTimestamp: shiftEnd.unix(),
        driverConfirmed: 0
      }

      let url = '/shifts'
      if (self.isEdit) {
        url = '/shifts/' + self.$store.state.provider.shiftForm.shiftId
        console.log('EDITING', url)
      }

      self.$sdk.post(url, request, r => {
        self.saving = false
        if (r.error) {
          self.error.show = true
          self.error.message = r.error.message
          return
        }
        self.$store.commit('provider/setShiftFormShow', false)
        self.$store.commit('provider/setShiftFormSave', true)
      })
    },
    deleteShift () {
      let self = this
      self.deleting = true

      self.$sdk.delete('/shifts/' + self.$store.state.provider.shiftForm.shiftId, {
        token: self.$store.state.session.sessionToken
      }, r => {
        self.deleting = false
        if (r.error) {
          self.error.show = true
          self.error.message = r.error.message
          return
        }
        self.$store.commit('provider/setShiftFormShow', false)
        self.$store.commit('provider/setShiftFormSave', true)
      })
    },
    isValid () {
      let self = this
      let day = moment(self.shiftDay).format('MM/DD/YYYY')
      let format = 'MM/DD/YYYY hh:mm A'
      let shiftStart = ''
      if (self.timeSelected == 'custom') {
        let hour = self.timeHour
        let minute = self.timeMinute
        let ampm = self.timeAmPm
        shiftStart = moment(day + ' ' + hour + ':' + minute + ' ' + ampm, format)
      } else {
        let timeSelected = '04:00 AM'
        if (self.timeSelected === '2pm') {
          timeSelected = '02:00 PM'
        } else if (self.timeSelected === '8pm') {
          timeSelected = '08:00 PM'
        }
        shiftStart = moment(day + ' ' + timeSelected, format)
      }

      let now = moment()
      if (self.timeSelected == -1) {
        self.error.show = true
        self.error.message = 'Please select which time you start.'
        return false
      }
      if (shiftStart.isBefore(now)) {
        self.error.show = true
        self.error.message = 'A shift should start in the future.'
        return false
      }

      if (self.selectedSector === -1) {
        self.error.show = true
        self.error.message = 'Please choose a sector.'
        return false
      }

      /*
      if (self.selectedSubsector === -1) {
        self.error.show = true
        self.error.message = 'Please choose a subsector.'
        return false
      }
      */

      self.error.show = false
      return true
    },
    hideForm () {
      if (this.saving) {
        return
      }
      this.$store.commit('provider/setShiftFormShow', false)
    },
    setAmPm () {
      let value = 'AM'
      if (this.timeAmPm === 'AM') {
        value = 'PM'
      }
      this.$store.commit('provider/setShiftFormTimeAmPm', value)
    },
    setHour (add) {
      let self = this
      let hour = this.$store.state.provider.shiftForm.timeHour

      if (add) {
        let value = hour + 1
        if (hour === 12) {
          value = 1
        }
        self.$store.commit('provider/setShiftFormTimeHour', value)
        return
      }

      let value = hour - 1
      if (hour === 1) {
        value = 12
      }
      self.$store.commit('provider/setShiftFormTimeHour', value)
      return
    },
    setMinute (add) {
      let self = this
      let minute = this.$store.state.provider.shiftForm.timeMinute

      if (add) {
        let value = minute + 5
        if (minute === 55) {
          value = 0
        }
        self.$store.commit('provider/setShiftFormTimeMinute', value)
        return
      }

      let value = minute - 5
      if (minute === 0) {
        value = 55
      }
      self.$store.commit('provider/setShiftFormTimeMinute', value)
      return
    },
    getSubsectors (reset) {
      let self = this
      if (reset) {
        self.$store.commit('provider/setShiftFormSelectedSubsector', -1)
      }
      self.$store.commit('provider/setShiftFormSubsectors', [])
      self.$sdk.get('/sectors/' + self.selectedSector + '/subsectors', {
        token: self.$store.state.session.sessionToken,
        polygon: 1
      }, r => {
        if (r.error) {
          return
        }
        self.$store.commit('provider/setShiftFormSubsectors', r.list)
      })
    }
  },
  watch: {
    show (value) {
      if (!value) {
        this.timeSelected = -1
        return
      }
      this.error.show = false
      if (this.selectedSector !== -1) {
        this.getSubsectors(false)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.shift-form-container {
  position: fixed;
  top: -100%;
  left: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.5);
  z-index: -1;
  transition: all 250ms;
  display: flex;
  justify-content: center;
  align-items: center;

  &.show {
    top: 0;
    opacity: 1;
    z-index: 12;
  }
}

.shift-form {
  background-color: #fff;
  width: 80%;
  max-width: 560px;
  // margin-left: auto;
  // margin-right: auto;
  // margin-top: calc(50% - 120px);
  overflow: hidden;
  border-radius: 3px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.3);

  & .title {
    background-color: #0D79F2;
    color: #fff;
    text-align: center;
    font-weight: 700;
    font-size: 14px;
    line-height: 14px;
    text-transform: uppercase;
    padding: 10px 0;
  }

  & .form-container {
    padding: 10px 15px 15px;
  }
}

.time-picker {
  margin-left: 8px;
  margin-top: 10px;
  width: 100%;

  & label {
    color: #0D79F2;
    font-weight: 700;
    font-size: 10px;
    line-height: 10px;
    display: block;
    margin-bottom: 10px;
    padding-left: 10px;
  }

  & .inline {
    display: inline-block;
    vertical-align: middle;
    float: left;
    text-align: center;
  }
  & .selection {
    text-align: center;
    width: 30%;

    & .value {
      font-size: 22px;
      font-weight: 700;
      color: #555;
    }

    & .control {
      font-size: 12px;
      color: #0D79F2;
      cursor: pointer;
      width: 100%;
    }
  }

  & .separator {
    line-height: 69px;
    height: 69px;
    color: #777;
    padding: 0 5px;
    width: 5%;
  }
}

.shift-duration {
  margin-left: 10px;
  margin-top: 90px;
}

.form-controls {
  margin-top: 30px;
  margin-left: 10px;

  &.show-delete {
    margin-top: 15px;
  }

  & .success, & .error {
    margin-bottom: 10px;
  }
}

.error-message {
  color: #F20D0D;
  font-size: 14px;
  font-weight: 700;
  text-align: center;
  margin-top: 15px;
  border: 1px solid #F20D0D;
  padding: 5px;
}
.field-input {
  & label {
    color: #0D79F2;
    font-weight: 700;
    font-size: 10px;
    line-height: 10px;
  }

  & input {
    margin-top: 0;
    font-size: 14px;
    padding: 7px 7px;
  }

  select {
    font-size: 14px;
    height: 37px;
    outline: 0;
    padding: 7px 7px;
    display: block;
    border-color: rgba(0,0,0,0.15);
    background-color: #fff;
    border-radius: 3px;
  }
}

.padding-L { padding-left: 7px; }
.padding-R { padding-right: 7px; }
.margin-T { margin-top: 20px; }

@media only screen and (max-width: 430px) {
  .shift-form-container, .small-7, .small-5, .shift-form {
    width: 100%;
  }

  /deep/ .vdp-datepicker__calendar {
    width: 100%;
  }

  .shift-form-container {
    display: flex;
    height: auto;
    align-items: center;
  }

  .shift-form {
    margin: 0;
    height: 100vh;
    overflow-y: auto;

    .form-container {
      padding-bottom: 40px;
    }

    .time-picker {
      margin-left: 0;
      label {
        padding-left: 0; 
      }
    }

    .shift-duration {
      margin-left: 0;
    }

    .form-controls {
      margin-left: 0;
      margin-top: 40px;
      display: flex;
      align-items: center;
      gap: 10px;
      .block {
        width: 50%;
        margin: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Provider/ShiftForm.vue